import React from 'react';
import { CalendarPlus, Eye } from 'lucide-react';
import StatusBadge from '../shared/StatusBadge';

const FollowUpBadge = ({ date }) => {
    if (!date) return null;

    const today = new Date();
    const followUpDate = new Date(date);
    today.setHours(0, 0, 0, 0);
    followUpDate.setHours(0, 0, 0, 0);

    let badgeClass = 'bg-gray-100 text-gray-800';
    let text = `Due ${followUpDate.toLocaleDateString()}`;

    if (followUpDate < today) {
        badgeClass = 'bg-red-100 text-red-800';
        text = 'Overdue';
    } else if (followUpDate.getTime() === today.getTime()) {
        badgeClass = 'bg-yellow-100 text-yellow-800';
        text = 'Due Today';
    }

    return <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${badgeClass}`}>{text}</span>;
};
const FollowUpBadgeList = ({ followups }) => {
    if (!followups || followups.length === 0) return null;

    // Get LAST followup
    const last = followups[followups.length - 1];

    const lastDate = new Date(`${last.date}T${last.time}:00`);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let badgeClass = '';
    let text = '';

    // Create date-only comparison
    const compareDate = new Date(lastDate);
    compareDate.setHours(0, 0, 0, 0);

    if (compareDate < today) {
        badgeClass = 'bg-red-100 text-red-800';
        text = 'Overdue';
    } else if (compareDate.getTime() === today.getTime()) {
        badgeClass = 'bg-yellow-100 text-yellow-800';
        text = 'Due Today';
    } else {
        badgeClass = 'bg-green-100 text-green-800';
        text = `Due ${lastDate.toLocaleDateString()}`;
    }

    return (
        <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${badgeClass}`}>
            {text}
        </span>
    );
};


const FollowUpTable = ({ enquiries, onSchedule, onOpenDetail }) => {
    return (
        <div className="overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-500">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                    <tr>
                        <th scope="col" className="px-6 py-3">Name</th>
                        <th scope="col" className="px-6 py-3">Source</th>
                        <th scope="col" className="px-6 py-3">Status</th>
                        <th scope="col" className="px-6 py-3">Next Follow-Up</th>
                        <th scope="col" className="px-6 py-3 text-right">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {enquiries.map(enquiry => (
                        <tr key={enquiry.id} className="bg-white border-b hover:bg-gray-50">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                <div>
                                    <div className="font-bold capitalize">{enquiry.user_name}</div>
                                    <div className="text-gray-500">{enquiry.phone}</div>
                                </div>
                            </th>
                            <td className="px-6 py-4">{enquiry.source}</td>
                            <td className="px-6 py-4">
                                <StatusBadge status={enquiry.status} />
                            </td>
                            <td className="px-6 py-4">
                               {enquiry.status != 'converted' &&  <FollowUpBadgeList followups={enquiry.followups} />}
                            </td>
                            <td className="px-6 py-4 text-right">
                                {enquiry.status != 'converted' && 
                                <button onClick={() => onSchedule(enquiry)} title="Schedule Follow-up" className="p-2 text-blue-500 hover:bg-blue-100 rounded-full transition-colors">
                                    <CalendarPlus size={18} />
                                </button>} 
                                <button onClick={() => onOpenDetail(enquiry)} title="View" className="p-2 text-blue-500 hover:bg-blue-100 rounded-full transition-colors">
                                    <Eye size={18} />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {enquiries.length === 0 && (
                <div className="text-center py-12 text-gray-500">
                    <p>No enquiries requiring follow-up.</p>
                </div>
            )}
        </div>
    );
};

export default FollowUpTable;
